import BusinessUnit from "@/components/master/business_unit/BusinessUnit.vue";
import BusinessUnitAdd from "@/components/master/business_unit/BusinessUnitAdd.vue";
import BusinessUnitDetail from "@/components/master/business_unit/BusinessUnitDetail.vue";
import BusinessUnitEdit from "@/components/master/business_unit/BusinessUnitEdit.vue";
import BusinessUnitUpload from "@/components/master/business_unit/BusinessUnitUpload.vue";

let routesBusinessUnit = [
    
    {
        path: '',
        meta: {
          title: "Sales System",
        },
        name: "BusinessUnitIndex",
        component: BusinessUnit
      },
      {
        path: 'add',
        meta: {
          title: "Sales System",
        },
        name: "BusinessUnitAdd",
        component: BusinessUnitAdd
      },
    
      {
        path: 'edit/:id',
        meta: {
          title: "Sales System",
        },
        name: "BusinessUnitEdit",
        component: BusinessUnitEdit
      },
    
      {
        path: 'detail/:id',
        meta: {
          title: "Sales System",
        },
        name: "BusinessUnitDetail",
        component: BusinessUnitDetail
      },
    
      {
        path: 'upload',
        meta: {
          title: "Sales System",
        },
        name: "BusinessUnitUpload",
        component: BusinessUnitUpload
      },
  ]
  
  export default routesBusinessUnit
  